import { useEffect } from "react";

export default function SpeakText({ textToSpeak, speechRate, onSpeechEnd }) {

    useEffect(() => {
        const speak = () => {
            const text = textToSpeak;
            const speech = new SpeechSynthesisUtterance(text);
            speech.lang = "en-IN";
            speech.rate = speechRate;
            speech.pitch = 1;

            const voices = window.speechSynthesis.getVoices();
            
            const indianVoice = voices.find(voice => voice.lang === "en-IN");
            if (indianVoice) {
                speech.voice = indianVoice;
            }

            speech.onend = () => {
                if (onSpeechEnd) {
                  onSpeechEnd(); // Call the callback function passed as a prop when speech ends
                }
              };

            window.speechSynthesis.speak(speech);
        };
        
        speak();
    }, [textToSpeak, speechRate, onSpeechEnd]);

    return null;
}